<template>
  <swiper :options="swiperOption" class="mySwiper">
    <swiper-slide v-for="(item, index) in list" :key="item.id">
      <div class="content" @click="$emit('change', index)">
        <div class="img-box">
          <img class="img" :src="item.picUrl" :alt="item.name" />
          <i v-if="current != index" class="stoptp"></i>
        </div>
        <p class="title">{{ item.name }}</p>
      </div>
    </swiper-slide>
    <div
      class="swiper-button-prev"
      slot="button-prev"
      style="top: 40%; left: 0"
    ></div>
    <div
      class="swiper-button-next"
      slot="button-next"
      style="top: 40%; right: 0"
    ></div>
  </swiper>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
// Import Swiper styles
import 'swiper/css/swiper.css'
export default {
  name: 'sourceSwiper',
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    list: {
      type: Array,
      require: true
    },
    current: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 5,
        spaceBetween: 30,
        // 设置前进后退按钮
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },

  // watch:{
  //   list(val) {
  //     if(val.length) {

  //     }
  //   }
  // },

  mounted() {},

  methods: {}
}
</script>

<style lang="less" scoped>
.mySwiper {
  width: 100%;
  height: 100%;
}
.swiper {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  // background: #f00;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  cursor: pointer;
}
.title {
  vertical-align: middle;
  font-size: 14px;
  line-height: 2;
}
.img-box {
  position: relative;
  flex: 1;
  width: 100%;
  height: 122px;

  .img {
    width: 100%;
    height: 100%;
    border-radius: 6px;
  }
}
.stoptp {
  position: absolute;
  top: calc(50% - 10px);
  left: calc(50% - 10px);
  width: 20px;
  height: 20px;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAeCAYAAAAy2w7YAAAAAXNSR0IArs4c6QAAAWhJREFUSA1j+P///0cgBoHjQGzCQCsAtgJB/AMy5wCxGNXtQ9iBwvoA5BUCMQvVLEQxHpNzDSjkRhXLMM3GKrIeKKpEkYVYjcUu+AMo3ALE3GRZiN1MvKKPgbIRJFuG10j8koeA0gZEW4jfLIKyf4EqpgOxMEELCRpFnIJ3QGU5QMyM00LizCFa1SWgSkeslhFtBGkKVwGVy6FYSJp+klR/A6quB2JOkIWMIK0oNlOf8xBoZDE9LAI7nYn6HsBq4l96WHQEaLUpAyiOaASeAM2NgvuPBpaACt82IEYtfKls0UagecpwXyAzqGTRdaA57sjmYrAptAjUsCkGYlYMg9EFyLQI1IiZB8Ti6Obh5JNh0QmgHlOcBuKSIMGi50C18UDMiMssvOJEWPQLqKYbiHnxGkRIkoBF24DyaoTMIEoeh0W3geI+RBlArCI0iz4D+RVAzEasfqLVAQ19AcSg5LoYiKWI1kiiQgCMBLnEEcfDSgAAAABJRU5ErkJggg==);
  background-size: 100% 100%;
}

.swiper-button-prev:after,
.swiper-button-next:after {
  color: #fff;
  font-size: 28px;
}
</style>
